import {Component, input, Input, OnInit} from '@angular/core';
import {NotificationMessage} from '../../../models/notification-message';
import { CopyableDirective } from '../../../directives/copyable.directive';
import { AppDatePipe } from '../../../pipes/app-date.pipe';

@Component({
    selector: 'app-base-notification',
    templateUrl: './base-notification.component.html',
    styleUrls: ['./base-notification.component.scss'],
    imports: [CopyableDirective, AppDatePipe]
})
export class BaseNotificationComponent {

    notification = input.required<NotificationMessage>();

}
